<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
  count: { type: Number, default: 0 },
  countLabel: { type: String, default: '' },
  modelValue: { type: String, default: 'recent_activity' },
  options: { type: Array, default: () => [] },
  statusBucket: { type: String, default: 'in_negotiation' },
  supportText: { type: String, default: '' },
});

const emit = defineEmits(['update:modelValue', 'change']);
const isOpen = ref(false);

const activeOption = computed(
  () =>
    props.options.find(option => option.value === props.modelValue) ||
    props.options[0] ||
    {}
);

const countLabel = computed(() => {
  if (props.countLabel) return props.countLabel;
  if (props.statusBucket === 'canceled') {
    return `${props.count} Propostas ${
      props.count === 1 ? 'cancelada' : 'canceladas'
    }`;
  }
  if (props.statusBucket === 'finished') {
    return `${props.count} Propostas ${
      props.count === 1 ? 'finalizada' : 'finalizadas'
    }`;
  }
  return `${props.count} Propostas em andamento`;
});

const sortSupportText = computed(
  () => `Ordenadas por ${activeOption.value.label || 'Atividade mais recente'}`
);

const selectOption = option => {
  emit('update:modelValue', option.value);
  emit('change', option.value);
  isOpen.value = false;
};
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div
    class="flex flex-col gap-3 px-4 py-4 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-10"
  >
    <div>
      <p class="text-[13px] text-lais-text-body">
        <span
          class="text-lais-primary underline decoration-lais-gold decoration-[1.5px] underline-offset-[3px]"
        >
          {{ countLabel }}
        </span>
      </p>
      <p v-if="supportText" class="mt-1 text-[12px] text-lais-text-muted">
        {{ supportText }}
      </p>
      <p class="mt-1 text-[12px] text-lais-text-muted">
        {{ sortSupportText }}
      </p>
    </div>

    <div class="relative">
      <button
        type="button"
        class="inline-flex h-9 items-center gap-2 rounded-full border border-lais-border bg-white px-3 text-[12px] font-semibold text-lais-text transition-colors hover:border-lais-primary hover:text-lais-primary"
        @click="isOpen = !isOpen"
      >
        <span class="i-lucide-arrow-up-down size-4" aria-hidden="true" />
        Ordenar por
      </button>
      <div
        v-if="isOpen"
        class="absolute right-0 z-20 mt-2 w-56 overflow-hidden rounded-lais border border-lais-border bg-white py-1 shadow-lais-pop"
      >
        <button
          v-for="option in options"
          :key="option.value"
          type="button"
          class="flex w-full items-center justify-between gap-3 px-3 py-2 text-left text-[13px] hover:bg-lais-bg-soft"
          :class="
            modelValue === option.value
              ? 'font-semibold text-lais-primary'
              : 'text-lais-text-body'
          "
          @click="selectOption(option)"
        >
          <span>{{ option.label }}</span>
          <span
            v-if="modelValue === option.value"
            class="i-lucide-check size-4"
            aria-hidden="true"
          />
        </button>
      </div>
    </div>
  </div>
</template>
